import type { I18nOptions } from 'vue-i18n';

export const datetimeFormats: I18nOptions['datetimeFormats'] = {
  'de-DE': {
    shortDate: { day: 'numeric', month: 'numeric', year: 'numeric' },
    shortTime: { hour: 'numeric', minute: 'numeric', hour12: false },
    shortDateTime: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
    mediumDate: { day: 'numeric', month: 'short', year: 'numeric' },
    mediumTime: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false },
    mediumDateTime: {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
    },
    longDate: { day: 'numeric', month: 'long', year: 'numeric' },
    longTime: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short',
      hour12: false,
    },
    longDateTime: {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short',
      hour12: false,
    },
    fullDate: { day: 'numeric', month: 'numeric', year: 'numeric' },
    fullTime: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false },
    fullDateTime: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false,
    },
    weekday: { weekday: 'long' },
    shortWeekday: { weekday: 'short' },
    weekdayAndTime: { weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: false },
    shortWeekdayAndTime: { weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false },
  },
  'en-US': {
    shortDate: { month: 'numeric', day: 'numeric', year: 'numeric' },
    shortTime: { hour: 'numeric', minute: 'numeric', hour12: true },
    shortDateTime: {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
    mediumDate: { month: 'short', day: 'numeric', year: 'numeric' },
    mediumTime: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true },
    mediumDateTime: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    },
    longDate: { month: 'long', day: 'numeric', year: 'numeric' },
    longTime: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short',
      hour12: true,
    },
    longDateTime: {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short',
      hour12: true,
    },
    fullDate: { month: 'long', day: 'numeric', year: 'numeric' },
    fullTime: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true },
    fullDateTime: {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    },
    weekday: { weekday: 'long' },
    shortWeekday: { weekday: 'short' },
    weekdayAndTime: { weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: false },
    shortWeekdayAndTime: { weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false },
  },
};
